var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var Divider_1 = __importDefault(require("./Divider"));
exports.Divider = Divider_1.default;
exports.default = Divider_1.default;
//# sourceMappingURL=index.js.map